import { useTranslation } from 'react-i18next';

import { Button } from '../buttons/Button';
import { Modal } from '../modal/Modal';

import styles from './AiAssistantModal.module.scss';

type DeleteChatModalProps = {
  chatTitle: string;
  onClose: () => void;
  onConfirm: () => void;
};

export function DeleteChatModal({
  chatTitle,
  onClose,
  onConfirm,
}: DeleteChatModalProps) {
  const { t } = useTranslation();

  return (
    <Modal
      actions={
        <>
          <Button onClick={onClose} variant="secondary">
            {t('app.aiAssistant.cancel')}
          </Button>
          <Button onClick={onConfirm} data-testid="ai-assistant-delete-confirm">
            {t('app.aiAssistant.deleteChatConfirm')}
          </Button>
        </>
      }
      modalType="action"
      onClose={onClose}
      opened
      size={420}
      title={t('app.aiAssistant.deleteChat')}
    >
      <p className={styles['confirm-text']}>
        {chatTitle
          ? t('app.aiAssistant.deleteChatMessageNamed', { title: chatTitle })
          : t('app.aiAssistant.deleteChatMessage')}
      </p>
    </Modal>
  );
}
